import React, {useEffect} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";

import LookFeatureInfo3dViewer from "./lookFeatureInfo3dViewer";
import {toggleLoader} from "../../../../../actions/actionFunctions";
import {LookAugmentRealityIcon} from "../../../../common/icons";
import COLOR_THEMES from "../../../../../colorThemes";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";

// import {isAndroid} from "../../../../../misc/helpers";
// import {baseNewImagesPath} from "../../../../assets";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {getDbFeatureProperty} from "../../lookFunctions2";

const LookFeatureInfo3d = (props) => {

  const {lookActiveFeature, isMobile, arButtonOnly, toggleLoader, activeTheme, intl} = props;

  let timeoutId;

  useEffect(() => {
    return () => {
      clearTimeout(timeoutId)
    }
  })

  if (!lookActiveFeature || !Array.isArray(lookActiveFeature.dbFeature[getDbFeatureProperty("lixilAR3DUrls")])) {
    return null
  }
  const threeDSrc = lookActiveFeature.dbFeature[getDbFeatureProperty("lixilAR3DUrls")].map(src => {
    src = src.replace("s3.amazonaws.com/qc-lixil-3dfiles", "dv84u4f1bblk2.cloudfront.net");
    return src
  })
  let glb = threeDSrc.find(url => url.includes(".glb"));
  let usdz = threeDSrc.find(url => url.includes(".usdz"));
  let hdr = threeDSrc.find(url => url.includes(".hdr"));

  const enableArLoader = () => {
    Analytics.sendClickEvent(IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureInfoContent3dAr
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureInfoContent3dAr
    );
    // if (isIframe()) {
    //   const loaderPath = baseNewImagesPath+'/translates/ar_lixil_loader.html';
    //   const windowRef = window.open(loaderPath, '_blank');
    //   windowRef.ar_file = isIOSDevice() ? usdz : glb;
    //   return false
    // }
    toggleLoader(true, "", "", true);
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      toggleLoader(false)
    }, 3000)
  }

  const arButton = (
    <IconButton aria-label={intl.formatMessage({id:"look.feature.info.augButton"})}
                slot="ar-button"
                onClick={enableArLoader}
                className={"look-icon look-icon--white2 look-icon--disabled-hover look-icon--with-shadow"
                + (IS_PRODUCT_JOURNEY || !arButtonOnly ? " lk-info__ar-button" : "")
                // + (isAndroid() ? " lk-info__ar-button--android" : "")
    }>
      <SvgIcon>
        <LookAugmentRealityIcon color={COLOR_THEMES[activeTheme].primary} />
      </SvgIcon>
      {IS_PRODUCT_JOURNEY ? (
        <span className="lk-info__ar-button-text">
          <FormattedMessage id="grohe.feature.info.augButton"/>
        </span>
      ) : null}
    </IconButton>
  );
// lk-button__mobile-ar-button look-icon look-icon--with-shadow
  return (
    <LookFeatureInfo3dViewer glb={glb} hdr={hdr} usdz={usdz} isMobile={isMobile} arButtonOnly={arButtonOnly}
                             arButton={arButton}/>
  )
};

LookFeatureInfo3d.propTypes = {
  arButtonOnly: PropTypes.bool
}

const mapStateToProps = (store) => {
  const {lookActiveFeature} = store.lookState;
  const {isMobile, activeTheme} = store.serverState;
  return {
    lookActiveFeature,
    isMobile,
    activeTheme,
  };
};

const mapDispatchToProps = {
  toggleLoader
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFeatureInfo3d)
)
